"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulatorTransport = void 0;
const utils_1 = require("@streamr/utils");
const ConnectionManager_1 = require("../ConnectionManager");
const ConnectorFacade_1 = require("../ConnectorFacade");
class SimulatorTransport extends ConnectionManager_1.ConnectionManager {
    constructor(localPeerDescriptor, simulator) {
        super({
            createConnectorFacade: () => new ConnectorFacade_1.SimulatorConnectorFacade(localPeerDescriptor, simulator),
            metricsContext: new utils_1.MetricsContext(),
            allowIncomingPrivateConnections: false
        });
    }
}
exports.SimulatorTransport = SimulatorTransport;
//# sourceMappingURL=SimulatorTransport.js.map